import { useMemo } from "react";
import type * as type from "@vTypes";
import {
  buildShiftLookupMaps,
  mergeShiftsForCellLookup,
  type ShiftLookupMaps,
} from "@/utils/shift-util";
import type { ShiftReturnType } from "@/hooks/roster-craete/useShiftsQuery";

/**
 * `availableShifts`와 `/shifts` 응답을 id 기준 병합 후 `buildShiftLookupMaps`.
 * Roster_create `TableBody_base`와 동일 패턴: `{ lookupMaps }` 만 반환.
 */
export function useShiftLookupMaps(
  defaultShiftCode: type.availableShifts[],
  shiftsData: ShiftReturnType | undefined | null
): {
  lookupMaps: ShiftLookupMaps<type.availableShifts>;
} {
  return useMemo(() => {
    const merged = mergeShiftsForCellLookup(
      defaultShiftCode,
      shiftsData != null
        ? (shiftsData as unknown as type.availableShifts[])
        : undefined
    );
    return { lookupMaps: buildShiftLookupMaps(merged) };
  }, [defaultShiftCode, shiftsData]);
}
